export default __webpack_public_path__ + "static/media/radgradhome.a2ab06eb.png";